<template>
        <div class="contractListBox">
            <el-tabs v-model="activeName" @tab-click="handleClick">
<!--                签署中-->
                <el-tab-pane label="签署中" name="first">
                    <signingPage v-if="activeName === 'first'"></signingPage>
                </el-tab-pane>
<!--                已完成-->
                <el-tab-pane label="已完成" name="second">
                    <accomplishPage v-if="activeName === 'second'"></accomplishPage>
                </el-tab-pane>
<!--                已作废-->
                <el-tab-pane label="已作废" name="third">
                    <invalidatePage v-if="activeName === 'third'"></invalidatePage>
                </el-tab-pane>
<!--                已过期-->
                <el-tab-pane label="已过期" name="fourth">
                    <overdue v-if="activeName === 'fourth'"></overdue>
                </el-tab-pane>
<!--                已拒签-->
                <el-tab-pane label="已拒签" name="fifth">
                    <refusalOfVisa v-if="activeName === 'fifth'"></refusalOfVisa>
                </el-tab-pane>
<!--                发起失败-->
                <el-tab-pane label="发起失败" name="sixth">
                    <initiationFailure v-if="activeName === 'sixth'"></initiationFailure>
                </el-tab-pane>
            </el-tabs>
        </div>
</template>

<script>
    import signingPage from './components/signingPage';
    import accomplishPage from './components/accomplishPage';
    import invalidatePage from './components/invalidatePage';
    import overdue from './components/overdue'
    import refusalOfVisa from './components/refusalOfVisa'
    import initiationFailure from  './components/initiationFailure'
    export default {
        name: 'wholeContract',
        data(){
            return{
                activeName:'first'
            }
        },
        components:{
            signingPage,
            accomplishPage,
            invalidatePage,
            overdue,
            refusalOfVisa,
            initiationFailure
        },
        methods:{
            handleClick(tab, event){
                sessionStorage.setItem('currentTab2', tab.name)
            }
        },
        created() {
            let name = sessionStorage.getItem('currentTab2')
            // 判断是否存在currentTab，即tab页之前是否被点击切换到别的页面
            if(name){
                this.activeName = name
            }
        },
    };
</script>

<style scoped>
    /*合同列表*/
    .contractListBox{
        width: 100%;
        /*height: 600px;*/
        background-color: #fff;
        padding: 20px;
        border-radius: 5px;
    }
    /deep/.el-tabs--top{
        width: 95%;
        padding: 0px 0px;
    }
    /deep/.el-tabs__item{
        padding: 0px 35px;
    }
    /deep/ .is-active{
        color: #3d62f6;
    }
    /deep/ .el-tabs__active-bar{
        background-color: #3d62f6;
    }
</style>
